import { supabase } from '../supabase';
import { Game } from './types';

// Função para adicionar um novo jogo
export async function addGame(game: Omit<Game, 'id' | 'created_at' | 'updated_at' | 'slug'>) {
  try {
    // Preparar os dados para inserção, SEM incluir o slug explicitamente
    const gameData = {
      ...game,
      // Garantir que arrays vazios sejam inseridos como arrays vazios, não como null
      categories: game.categories || [],
      mechanics: game.mechanics || [],
      themes: game.themes || [],
      artists: game.artists || [],
      designers: game.designers || [],
    };
    
    // Inserir o jogo no banco
    const { data, error } = await supabase
      .from('games')
      .insert(gameData)
      .select()
      .single();
    
    if (error) throw error;
    
    if (!data) {
      throw new Error('Nenhum dado retornado após inserir jogo');
    }
    
    console.log('Jogo adicionado com sucesso:', data.id);
    return data;
  } catch (error) {
    console.error('Erro ao adicionar jogo:', error);
    throw error;
  }
}

// Função para atualizar um jogo existente
export async function updateGame(id: string, gameData: Partial<Game>) {
  try {
    // Remover campos que não devem ser atualizados diretamente
    const { id: _id, created_at, updated_at, slug: _slug, ...updateData } = gameData as any;
    
    const { data, error } = await supabase
      .from('games')
      .update(updateData)
      .eq('id', id)
      .select()
      .single();
    
    if (error) throw error;
    
    if (!data) {
      throw new Error(`Jogo com ID ${id} não encontrado ou não atualizado`);
    }
    
    console.log('Jogo atualizado com sucesso:', id);
    return data;
  } catch (error) {
    console.error(`Erro ao atualizar jogo com ID ${id}:`, error);
    throw error;
  }
}

// Função para excluir um jogo
export async function deleteGame(id: string) {
  try {
    const { error } = await supabase
      .from('games')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return true;
  } catch (error) {
    console.error(`Erro ao excluir jogo com ID ${id}:`, error);
    throw error;
  }
} 